/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { PutUsersIdMutationRequest, PutUsersIdMutationResponse, PutUsersIdPathParams, PutUsersId400, PutUsersId403 } from '../entities/PutUsersId'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPutUsersIdUrl(id: PutUsersIdPathParams['id']) {
  return `/users/${id}` as const
}

/**
 * @description Обновление пользователя админом компании
 * @summary Обновление пользователя
 * {@link /users/:id}
 */
export async function putUsersId(
  id: PutUsersIdPathParams['id'],
  data: PutUsersIdMutationRequest,
  config: Partial<RequestConfig<PutUsersIdMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<PutUsersIdMutationResponse, ResponseErrorConfig<PutUsersId400 | PutUsersId403>, PutUsersIdMutationRequest>({
    method: 'PUT',
    url: getPutUsersIdUrl(id).toString(),
    data,
    ...requestConfig,
  })
  return res.data
}